import "./contact.css";
import { toast } from "react-toastify";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailTwoToneIcon from "@mui/icons-material/EmailTwoTone";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import ContactForm from "../../components/ContactForm/ContactForm";
export default function Contact() {
  return (
    <section className="contactPage">
      <div className="heading">
        <small>Get in touch...</small>
        <h1> Contact Us</h1>
      </div>
      <div className="messageUsSection">
        <div className="textContent">
          <h3>Message Us</h3>
          <p>
            If you have any questions or inquiries, feel free to reach out to
            us. We would love to hear from you and assist in any way we can.
          </p>
          <p className="location">
            <p>
              <span>
                <LocationOnIcon />
              </span>
              <p>
                38/40. AMARAPATHI VINAYAGAR KOVIL NEAR KAMARAJAR STREET,
                Viluppuram DT, PinCode: 605 602
              </p>
            </p>
            {/* <p>
              <span>
                <LocationOnIcon />
              </span>
              Tiruttani Showroom: 321/322 Ma Po Si Salai, Tiruttani
            </p> */}
            <p>
              {" "}
              <span>
                <EmailTwoToneIcon />
              </span>{" "}
              @gmail.com
            </p>
            <p>
              <span>
                <LocalPhoneRoundedIcon />
              </span>
              <p>MOBILE : 93333 33092,94430 91392</p>
            </p>
          </p>
        </div>

        <div className="contactForm">
          <ContactForm />
        </div>
      </div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3903.423750764356!2d79.49152067423051!3d11.945135988283777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5356c063472b39%3A0xddddb0485cd92a51!2sVimal%20Jewellery!5e0!3m2!1sen!2sin!4v1743665451479!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{border:0}}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </section>
  );
}
